export default "/icons/mysql_icon.svg";